/*
 * @Description: 路由
 * @Date: 2025-07-16 15:29:41
 */
export const route = [
  {
    path: '/customer-target-manage',
    name: 'customer-target-manage',
    meta: {
      title: '客户目标管理'
    },
    component: () => import('../views/customer-target-manage-list.vue')
  }
];
